import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { LoginUserResponse } from '../type';

interface AppState {
  data: {};
}

const initialState: AppState = {
  data: {},
};

export const appReducer = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateAppConfig: (state, action: PayloadAction<LoginUserResponse>) => {
      state.data = { ...state.data, ...action.payload };
    },
    clearAppConfig: (state) => {
      state.data = initialState;
    },
  },
});

export const { updateAppConfig, clearAppConfig } = appReducer.actions;

export const selectAppConfig = (state: RootState) => state.app;

export default appReducer.reducer;
